module.exports = __webpack_public_path__ + "img/20_DSC7816-min.83a9505b.jpg";